'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
var $ = require("jquery");
var Menu = /** @class */ (function () {
    function Menu() {
        $('.trigHamburgerSwitch').on('click', function (e) {
            var isOpen = $(e.currentTarget).attr('data-is-open');
            if (isOpen === 'false') {
                $(e.currentTarget).attr('data-is-open', 'true');
                $('.bulletHamburgerMenu').fadeIn(500);
                $('body').addClass('no-scroll');
            }
            else {
                $(e.currentTarget).attr('data-is-open', 'false');
                $('.bulletHamburgerMenu').fadeOut(500);
                $('body').removeClass('no-scroll');
            }
        });
        $('.trigHamburgerSelect').on('click', function () {
            $('.trigHamburgerSwitch').attr('data-is-open', 'false');
            $('.bulletHamburgerMenu').fadeOut(500);
            $('body').removeClass('no-scroll');
        });
    }
    Menu.prototype.initCopy = function () {
    };
    return Menu;
}());
exports.Menu = Menu;
exports.default = Menu;
